<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 no-padding mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Inspection & Audit</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <h3 class="page-title obs-card-title" style="text-align: center">
          <span class="page-sub-title">
            <ng-container *ngIf="inspectionId > 0"
              >Inspection {{ inspectionId }}</ng-container
            >

            <ng-container *ngIf="inspectionId === 0"
              >New Inspection</ng-container
            >
          </span>

          <button
            *ngIf="inspectionId > 0"
            (click)="isNext ? onNextClick() : $event.preventDefault()"
            [ngClass]="isNext ? 'cursor-pointer' : 'disabled'"
            class="pull-right btn btn-primary primary-btn"
          >
            <i class="fa fa-angle-right"></i>
          </button>

          <button
            *ngIf="inspectionId > 0"
            (click)="isPrevious ? onPreviousClick() : $event.preventDefault()"
            [ngClass]="isPrevious ? 'cursor-pointer' : 'disabled'"
            class="pull-right btn btn-primary primary-btn"
          >
            <i class="fa fa-angle-left"></i>
          </button>
        </h3>

        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ "INSPECTION.UNIT" | translate }}
              <span class="name-mandatory">*</span>
            </span>
            <p-tree
              [value]="unitTree"
              selectionMode="single"
              (onNodeSelect)="nodeSelected($event)"
              [(selection)]="selectedUnit"
              [styleClass]="disableInspection ? 'disabled' : 'cursor-pointer'"
            ></p-tree>
            <span class="error-msg-colour" *ngIf="unitError"
              >Please select unit</span
            >
          </div>
          <div class="sub-section-wrapper" [hidden]="isEmployeeUnit">
            <span class="section-sub-title">Contract Number</span>
            <!-- <input type="text" maxlength="50" value="" class="form-control margin-top-10" id="name"
						  [(ngModel)]="ContractNumber" placeholder="Contract Number"
						  [disabled]="true"> -->
            <p-dropdown
              [options]="contracts"
              placeholder="Select"
              [(ngModel)]="selectedContractId"
              [style]="{ width: '100%' }"
              (onChange)="checkHolder($event)"
            >
            </p-dropdown>

            <div *ngIf="isContractErrorMsg && !inspectionRequest.ContractId">
              <span class="error-msg-colour">Please select Contract</span>
              <span class="error-msg-colour" *ngIf="!isHasContractDetails"
                >Contract Holder is not available for this contract. Please
                contact admin to update these details.
              </span>
            </div>

            <!-- <span class="error-msg-colour"
							*ngIf="csForm.submitted && CSForm.get('Contract').hasError('required')">Please select Contract </span>
							<span class="error-msg-colour"
							*ngIf="!isHasContractDetails">Contract Holder is not available for this contract. Please contact admin to update these details. 
						  </span> -->
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.INSPECTION_NAME" | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-dropdown
              [options]="inspectionCheckLists"
              placeholder="Select"
              [disabled]="disableInspection"
              (onChange)="setCheckListPoint($event)"
              [(ngModel)]="inspectionRequest.CheckListId"
              [style]="{ width: '100%' }"
            >
            </p-dropdown>
            <div
              *ngIf="isInspectionNameErrorMsg && !inspectionRequest.CheckListId"
            >
              <span class="error-msg-colour"
                >{{ "INSPECTION.KINDLY_SELECT_INSPECTIONNAME." | translate }}
              </span>
            </div>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.INSPECTION_DESCRIPTION" | translate }}
              <span class="mandatory">*</span>
            </span>
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="inspectionRequest.InspectionDescription"
              [maxLength]="1000"
              [disabled]="disableInspection"
              (output)="getRemarks($event, 'Description', 0)"
            ></ara-textarea>
            <div
              *ngIf="
                isInspectionDescriptionErrorMsg &&
                !inspectionRequest.InspectionDescription
              "
            >
              <span class="error-msg-colour">{{
                "INSPECTION.KINDLY_SELECT_INSPECTIONDESCRIPTION." | translate
              }}</span>
            </div>
          </div>

          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.LOCATION" | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-dropdown
              [options]="locations"
              placeholder="Select"
              [(ngModel)]="selectedLocation"
              [disabled]="
                disableInspection ||
                (inspectionId > 0 &&
                  inspectionRequest.Status !== 'Draft' &&
                  isInactiveLocation &&
                  !independentPermissions.APP_Admin &&
                  !independentPermissions.HSE_Admin &&
                  !independentPermissions.SUPER_Admin)
              "
              [style]="{ width: '100%' }"
              (onChange)="saveLocation()"
            ></p-dropdown>
            <div *ngIf="isLocationErrorMsg && !inspectionRequest.LocationId">
              <span class="error-msg-colour">{{
                "INSPECTION.KINDLY_SELECT_LOCATION." | translate
              }}</span>
            </div>
            <div *ngIf="isInactiveLocation">
              <span class="error-msg-colour">This Location is In Active.</span>
            </div>
          </div>
          <ara-exact-location
            [Location]="inspectionRequest.ExactLocation"
            [Disabled]="disableInspection"
            (Output)="setLocation($event)"
          ></ara-exact-location>
          <div class="clearfix"></div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.CONTRACTOR_NAME" | translate }}
              <span class="mandatory">*</span>
            </span>
            <p-autoComplete
              [(ngModel)]="selectedContractor"
              [suggestions]="userResults"
              appendTo="body"
              [disabled]="
                (!selectedUnit && inspectionId === 0) || disableInspection
              "
              (completeMethod)="getUsersByUsageType($event)"
              placeholder="Employee Name"
              field="FullName"
              [minLength]="1"
              [style]="{ width: '100%' }"
              [inputStyle]="{ width: '100%' }"
              [forceSelection]="true"
            >
              <ng-template let-employee pTemplate="item">
                <span [title]="employee.Email">{{ employee.FullName }}</span>
              </ng-template>
            </p-autoComplete>
            <div
              *ngIf="
                isContractorNameErrorMsg && selectedContractor?.UserId === 0
              "
            >
              <span class="error-msg-colour">{{
                "INSPECTION.KINDLY_SELECT_CONTRACTOR_NAME." | translate
              }}</span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">
              {{ "INSPECTION.DATE " | translate }}
              &amp;
              {{ "INSPECTION.TIME" | translate }}
              <span class="mandatory">*&nbsp;&nbsp;</span>
            </span>
            <p-calendar
              [showIcon]="true"
              dateFormat="dd/mm/yy"
              [maxDate]="dateTime"
              [showTime]="true"
              placeholder=""
              [(ngModel)]="inspectionRequest.InspectionDate"
              class="custom-datepicker"
              readonlyInput="true"
              required
              #timeOfUse="ngModel"
              [disabled]="disableInspection"
              monthNavigator="true"
              yearNavigator="true"
              yearRange="1950:2100"
            ></p-calendar>
            <div
              *ngIf="
                isInspectorNameErrorMsg && !inspectionRequest.InspectionDate
              "
            >
              <span class="error-msg-colour">{{
                "INSPECTION.KINDLY_ENTER_DATE_AND_TIME_OF_THE_INSPECTION."
                  | translate
              }}</span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.Inspection_Instruction" | translate }}
              <i
                class="fa fa-question"
                data-toggle="tooltip"
                pTooltip="This document is a part of checklist creation which is managed by Admin. Documents cannot be added from this screen."
                tooltipPosition="top"
              ></i>
            </span>
            <ara-file-upload
              [accept]="accept"
              [multiple]="multiple"
              [(inputFiles)]="inspectionRequest.InspectionInstruction"
              disabled="true"
            >
            </ara-file-upload>
            <ara-files-previewer
              [files]="instructionDocuments"
            ></ara-files-previewer>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.Inspector_Name" | translate }}
              <span class="mandatory">*&nbsp;</span>

              <label style="color: black" *ngIf="false">{{
                loggedInUserJSON.FullName
              }}</label>
              <label *ngIf="false">{{ selectedInspector.FullName }}</label>
              <p-multiSelect
                [options]="allInspectorsData"
                [(ngModel)]="selectedInspectors"
                placeholder="Select"
                [style]="{ width: '100%' }"
                (onChange)="changeValueofInspector()"
              >
              </p-multiSelect>
              <div *ngFor="let inspector of displaySelectedInspectorsNames">
                <label style="font-weight: normal"
                  >{{ inspector.Number }}. {{ inspector.Name }}
                </label>
              </div>
            </span>
            <div
              *ngIf="
                isInspectorIdsMsg &&
                (!selectedInspectors || selectedInspectors.length == 0)
              "
            >
              <span class="error-msg-colour">{{
                "INSPECTION.KINDLY_SELECT_INSPECTORNAME." | translate
              }}</span>
            </div>
          </div>
          <ara-category
            *ngIf="permissions.INSP_Admin || permissions.INSP_Admin_Unit"
            [moduleId]="moduleId"
            [sourceId]="inspectionId"
            [isActive]="isActive"
            [disabled]="disableInspection"
            (categoryCheckedValueEmittedData)="
              categoryCheckedEmittedValue($event)
            "
          >
          </ara-category>
          <div class="clearfix"></div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.ITEMS TO BE CHECKED" | translate }}
              <span class="mandatory">*</span>
            </span>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>{{ "INSPECTION.CHECKLIST_POINT" | translate }}</th>
                    <th>{{ "INSPECTION.YES" | translate }}</th>
                    <th>{{ "INSPECTION.NO" | translate }}</th>
                    <th>{{ "INSPECTION.NA" | translate }}</th>
                    <th>{{ "INSPECTION.REMARKS" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let check of checklistPoints; let i = index">
                    <td [pTooltip]="check.TooltipDescription">
                      {{ i + 1 }}. {{ check.CheckListPoint
                      }}<i
                        class="fa fa-question pull-right"
                        style="color: lightskyblue"
                      ></i>
                    </td>
                    <td
                      style="text-align: center"
                      *ngFor="let checklist of checklistPointDescr"
                    >
                      <input
                        type="radio"
                        [name]="check.CheckListPoint"
                        [value]="checklist.Id"
                        [(ngModel)]="check.Value"
                        [disabled]="disableInspection"
                        (change)="changeValue($event, checklist, check)"
                      />
                    </td>
                    <td style="text-align: center">
                      <ara-remarks
                        [disabled]="disableInspection"
                        [RemarkText]="check.RemarkText"
                        [RemarkFiles]="check.Files"
                        (finalRemark)="getRemarks($event, 'CheckListRemark', i)"
                      ></ara-remarks>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.DID THE JOB STOPPED" | translate }}
            </span>
            <label class="radio-inline">
              &nbsp;&nbsp;&nbsp;&nbsp;<input
                type="radio"
                [(ngModel)]="IsJobStopped"
                value="true"
                name="whatdid"
                [disabled]="disableInspection"
              />Yes
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                [(ngModel)]="IsJobStopped"
                value="false"
                name="whatdid"
                [disabled]="disableInspection"
              />No
            </label>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title"
              >{{ "INSPECTION.REMARKS" | translate }}
            </span>
            <ara-textarea
              rows="4"
              cols="30"
              [sourceText]="inspectionRequest.Remarks"
              [maxLength]="1000"
              [disabled]="disableInspection"
              (output)="getRemarks($event, 'Remarks', 0)"
            ></ara-textarea>
            <div *ngIf="isRemarksErrorMsg && !inspectionRequest.Remarks">
              <span style="color: red">{{
                "INSPECTION.KINDLY_ENTER_REMARKS." | translate
              }}</span>
            </div>
          </div>
          <div class="sub-section-wrapper">
            <span class="section-sub-title">Upload Documents </span>
            <ara-file-upload
              [accept]="accept"
              [multiple]="multiple"
              [(inputFiles)]="inspectionRequest.InspectionFiles"
              [disabled]="disableInspection"
            >
            </ara-file-upload>
            <ara-files-previewer
              [files]="uploadedDocuments"
            ></ara-files-previewer>
          </div>
          <ara-record-actions
            *ngIf="inspectionId > 0"
            [SourceId]="inspectionId"
            ModuleName="Inspection"
            [ShowCancel]="
              (permissions.INSP_Admin || permissions.INSP_Admin_Unit) &&
              inspectionRequest.Status !== 'Deleted' &&
              inspectionRequest.Status !== 'Cancelled'
            "
            [ShowDelete]="
              independentPermissions.SUPER_Admin &&
              inspectionRequest.Status !== 'Cancelled' &&
              inspectionRequest.Status !== 'Deleted'
            "
            [ShowRestate]="
              (permissions.INSP_Admin || permissions.INSP_Admin_Unit) &&
              inspectionRequest.Status === 'Cancelled'
            "
            [Status]="inspectionRequest.Status"
            (output)="getOutput($event)"
          ></ara-record-actions>
          <div class="clearfix"></div>
        </div>
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
          *ngIf="
            permissions.INSP_Admin ||
            permissions.INSP_Admin_Unit ||
            (inspectionId > 0 &&
              actionList.length >= 1 &&
              actionList[0].ActionId > 0)
          "
        >
          <div class="section-wrapper add-action-wrapper">
            <span class="section-title">{{
              "INSPECTION.ADD_ACTION_YOU_WANT_TO_TAKE" | translate
            }}</span>
            <div class="table-responsive margin-bottom-20 add-action-table">
              <table
                style="align-content: center"
                class="table table-bordered table-striped table-condensed tableheader table-red"
              >
                <tbody *ngFor="let action of actionList; let i = index">
                  <tr
                    *ngIf="
                      independentPermissions.SUPER_Admin ||
                      permissions.INSP_Admin ||
                      permissions.INSP_Admin_Unit ||
                      (!independentPermissions.SUPER_Admin &&
                        !permissions.INSP_Admin &&
                        !permissions.INSP_Admin_Unit &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <th colspan="7" class="action-details-th">
                      <a
                        class="action-details"
                        [ngClass]="
                          action.ActionId > 0 ? 'cursor-pointer' : 'disabled'
                        "
                        (click)="
                          action.ActionId > 0
                            ? showActions(action.ActionId, action.ProcessId)
                            : $event.preventDefault()
                        "
                        ><i class="fa fa-hand-o-up"></i>
                        {{ "INSPECTION.ACTION_DETAILS" | translate }}
                        <ng-container *ngIf="action.ActionId > 0">{{
                          action.ActionId
                        }}</ng-container>
                      </a>
                      <span class="action-details-status">
                        <label style="margin: 0"
                          >Status :<span style="margin-left: 5px">{{
                            action.Status
                          }}</span></label
                        >
                      </span>
                    </th>
                  </tr>
                  <tr
                    *ngIf="
                      independentPermissions.SUPER_Admin ||
                      permissions.INSP_Admin ||
                      permissions.INSP_Admin_Unit ||
                      (!independentPermissions.SUPER_Admin &&
                        !permissions.INSP_Admin &&
                        !permissions.INSP_Admin_Unit &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <td colspan="7">
                      <ara-textarea
                        rows="4"
                        cols="30"
                        [sourceText]="action.Action"
                        [maxLength]="1000"
                        [disabled]="
                          (!permissions.INSP_Admin &&
                            !permissions.INSP_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                            action?.Status === 'Closed' ||
                            action?.Status === 'Cancelled'
                        "
                        (output)="getRemarks($event, 'Action', i)"
                      ></ara-textarea>
                      <div
                        *ngIf="!action.Action && action.ShowActionErrorMessage"
                      >
                        <span class="error-msg-colour">{{
                          "INSPECTION.PROVIDE_ACTION_DETAILS" | translate
                        }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      independentPermissions.SUPER_Admin ||
                      permissions.INSP_Admin ||
                      permissions.INSP_Admin_Unit ||
                      (!independentPermissions.SUPER_Admin &&
                        !permissions.INSP_Admin &&
                        !permissions.INSP_Admin_Unit &&
                        action.Status !== 'Deleted')
                    "
                  >
                    <td style="width: 200px">
                      <strong>Action Owner</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.ActionOwner"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionOwner($event, i)"
                        (change)="selectActionOwner($event, i)"
                        placeholder="Action Owner"
                        appendTo="body"
                        field="FullName"
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                        [disabled]="
                          (!permissions.INSP_Admin &&
                            !permissions.INSP_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                            action?.Status === 'Closed' ||
                            action?.Status === 'Cancelled'
                        "
                      >
                        <ng-template let-actionowner pTemplate="item">
                          <span [title]="actionowner.Email">{{
                            actionowner.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                      <div *ngIf="action.ShowActionOwnerErrorMessage">
                        <span class="error-msg-colour">{{
                          "INSPECTION.KINDLY_SELECT_ACTION_OWNER" | translate
                        }}</span>
                      </div>
                    </td>
                    <td style="width: 200px">
                      <strong>Action Party</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.selectedActionParty"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionParty($event, i)"
                        (change)="selectActionParty($event, i)"
                        placeholder="Action Party"
                        field="FullName"
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        appendTo="body"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                        [disabled]="
                          (!permissions.INSP_Admin &&
                            !permissions.INSP_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                            action?.Status === 'Closed' ||
                            action?.Status === 'Cancelled'
                        "
                      >
                        <ng-template let-actionparty pTemplate="item">
                          <span [title]="actionparty.Email">{{
                            actionparty.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                      <div
                        class="margin-top-10"
                        *ngIf="action.ShowActionPartyErrorMessage"
                      >
                        <span class="error-msg-colour">{{
                          "INSPECTION.KINDLY_SELECT_ACTION_PARTY" | translate
                        }}</span>
                      </div>
                    </td>
                    <td style="width: 200px">
                      <strong>Action Verifier</strong>
                      <br />
                      <p-autoComplete
                        [(ngModel)]="action.selectedActionVerifier"
                        [suggestions]="userResults"
                        (completeMethod)="getUsersOnSearch($event)"
                        (onSelect)="selectActionVerifier($event, i)"
                        (change)="selectActionVerifier($event, i)"
                        placeholder="Action Verifier"
                        field="FullName"
                        [minLength]="1"
                        [style]="{ width: '100%' }"
                        appendTo="body"
                        [inputStyle]="{ width: '100%' }"
                        [forceSelection]="true"
                        [disabled]="
                          (!permissions.INSP_Admin &&
                            !permissions.INSP_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                            action?.Status === 'Closed' ||
                            action?.Status === 'Cancelled'
                        "
                      >
                        <ng-template let-actionVerifier pTemplate="item">
                          <span [title]="actionVerifier.Email">{{
                            actionVerifier.FullName
                          }}</span>
                        </ng-template>
                      </p-autoComplete>
                    </td>
                    <td style="width: 92px">
                      <strong>Priority</strong>
                      <br />
                      <select
                        class="form-control"
                        id="sel1"
                        [(ngModel)]="action.Priority"
                        [disabled]="
                          (!permissions.INSP_Admin &&
                            !permissions.INSP_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                            action?.Status === 'Closed' ||
                            action?.Status === 'Cancelled'
                        "
                      >
                        <option [ngValue]="0">Select</option>
                        <option [ngValue]="3">High</option>
                        <option [ngValue]="2">Medium</option>
                        <option [ngValue]="1">Low</option>
                      </select>
                      <div
                        *ngIf="
                          !action.Priority && action.ShowPriorityErrorMessage
                        "
                      >
                        <span class="error-msg-colour">{{
                          "INSPECTION.KINDLY_SELECT_PRIORITY" | translate
                        }}</span>
                      </div>
                    </td>
                    <td style="width: 150px">
                      <strong>Target Date</strong>
                      <br />
                      <div class="p-calendar">
                        <p-calendar
                          [showIcon]="true"
                          dateFormat="dd/mm/yy"
                          [showTime]="true"
                          placeholder=""
                          [(ngModel)]="action.TargetDate"
                          readonlyInput="true"
                          required
                          #timeOfUse="ngModel"
                          appendTo="body"
                          hideOnDateTimeSelect="true"
                          [disabled]="
                            (!permissions.INSP_Admin &&
                              !permissions.INSP_Admin_Unit &&
                              action.ActionId > 0) ||
                            action?.Status === 'Deleted' ||
                              action?.Status === 'Closed' ||
                              action?.Status === 'Cancelled'
                          "
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                        >
                        </p-calendar>
                        <div *ngIf="!action.TargetDate">
                          <span class="error-msg-colour">{{
                            "INSPECTION.KINDLY_SELECT_TARGET_DATE" | translate
                          }}</span>
                        </div>
                      </div>
                    </td>
                    <td style="width: 350px">
                      <ara-file-upload
                        [accept]="accept"
                        [multiple]="multiple"
                        [(inputFiles)]="action.Files"
                        [disabled]="
                          (!permissions.INSP_Admin &&
                            !permissions.INSP_Admin_Unit &&
                            action.ActionId > 0) ||
                          action?.Status === 'Deleted' ||
                            action?.Status === 'Closed' ||
                            action?.Status === 'Cancelled'
                        "
                      >
                      </ara-file-upload>
                      <ara-files-previewer
                        [files]="action.FilesPreview"
                      ></ara-files-previewer>
                    </td>
                    <td
                      style="width: 50px"
                      *ngIf="
                        action.Status === 'Open' ||
                        action.Status === 'Reopen' ||
                        action.Status === 'Accepted' ||
                        action.Status === 'Closed'
                      "
                    >
                      <a
                        *ngIf="action.ActionId === 0 && actionList.length > 1"
                        (click)="removeActionFromActionList(i)"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                      <a
                        (click)="
                          (permissions.INSP_Admin ||
                            permissions.INSP_Admin_Unit) &&
                          action.ActionId > 0 &&
                          (action?.Status !== 'Deleted' ||
                            action?.Status !== 'Cancelled')
                            ? cancelAssigned(action.ActionId, i)
                            : $event.preventDefault()
                        "
                        *ngIf="action.ActionId > 0"
                        [ngClass]="
                          (permissions.INSP_Admin ||
                            permissions.INSP_Admin_Unit) &&
                          action.ActionId > 0 &&
                          (action?.Status !== 'Deleted' ||
                            action?.Status !== 'Cancelled')
                            ? 'cursor-pointer'
                            : 'disabled'
                        "
                      >
                        <i
                          class="fa fa-times"
                          data-toggle="tooltip"
                          pTooltip="Cancel Action"
                          tooltipPosition="top"
                        ></i>
                      </a>
                      <a
                        (click)="
                          (permissions.INSP_Admin ||
                            permissions.INSP_Admin_Unit) &&
                          action.ActionId > 0 &&
                          (action?.Status !== 'Deleted' ||
                            action?.Status !== 'Cancelled')
                            ? deleteAssigned(action.ActionId, i)
                            : $event.preventDefault()
                        "
                        *ngIf="action.ActionId > 0"
                        [ngClass]="
                          (permissions.INSP_Admin ||
                            permissions.INSP_Admin_Unit) &&
                          action.ActionId > 0 &&
                          (action?.Status !== 'Deleted' ||
                            action?.Status !== 'Cancelled')
                            ? 'cursor-pointer'
                            : 'disabled'
                        "
                      >
                        <i
                          class="fa fa-trash"
                          data-toggle="tooltip"
                          pTooltip="Delete Action"
                          tooltipPosition="top"
                        ></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End table-responsive -->
            <a
              (click)="
                permissions.INSP_Admin || permissions.INSP_Admin_Unit
                  ? addAction()
                  : $event.preventDefault()
              "
              class="pull-right margin-top-10"
              [ngClass]="
                permissions.INSP_Admin || permissions.INSP_Admin_Unit
                  ? 'cursor-pointer'
                  : 'disabled'
              "
            >
              <i
                class="fa fa-plus"
                aria-hidden="true"
                style="padding-right: 6px"
              ></i
              >Add Action
            </a>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="breaker"></div>
        <footer>
          <button
            type="button"
            class="btn btn-primary primary-btn button-float-left button-back"
            (click)="backToOverview()"
          >
            <i class="fa fa-check"></i> Back To Overview
          </button>
          <button
            type="button"
            *ngIf="inspectionId && inspectionId > 0"
            (click)="ReportshowDialog()"
            class="btn btn-primary primary-btn button-report-log button-float-left"
          >
            Report Log
          </button>
          <button
            type="button"
            class="btn btn-primary primary-btn button-draft"
            (click)="saveAsDraft()"
            *ngIf="inspectionId === 0 || inspectionRequest.Status === 'Draft'"
          >
            <i class="fa fa-envelope"></i>Save As Draft
          </button>
          <button
            *ngIf="inspectionId > 0 && inspectionRequest.Status !== 'Draft'"
            type="button"
            class="btn btn-primary primary-btn button-pdf"
            (click)="downloadPDF()"
          >
            <i class="fa fa-file-pdf-o"></i> Download PDF
          </button>
          <button
            *ngIf="!inspectionId || inspectionRequest.Status === 'Draft'"
            type="button"
            class="btn btn-primary primary-btn button-submit"
            (click)="checkValidation()"
            [disabled]="
              !selectedContractor ||
              selectedContractor?.UserId === 0 ||
              selectedContractor?.UserId === null ||
              !inspectionRequest.InspectionDescription ||
              !selectedLocation ||
              !inspectionRequest.LocationId ||
              !inspectionRequest.CheckListId
            "
          >
            <i class="fa fa-check"></i> Submit
          </button>
          <button
            *ngIf="inspectionId > 0 && inspectionRequest.Status !== 'Draft'"
            type="button"
            class="btn btn-primary primary-btn button-update"
            (click)="checkValidation()"
            [disabled]="
              (editEnabled === false && !selectedContractor) ||
              selectedContractor?.UserId === 0 ||
              selectedContractor?.UserId === null ||
              !inspectionRequest.InspectionDescription ||
              !selectedLocation ||
              !inspectionRequest.LocationId ||
              !inspectionRequest.CheckListId ||
              !isUpdateAllowed ||
              isInactiveLocation
            "
          >
            <i class="fa fa-check"></i> Update
          </button>
        </footer>
      </div>
    </div>
  </div>
</div>
<div class="clearfix"></div>
<p-dialog
  header="Deletion Remarks"
  [(visible)]="deleteRecord"
  modal="modal"
  width="500"
>
  <ara-textarea
    [sourceText]="deletionReason"
    [maxLength]="1000"
    disabled="false"
    (output)="getRemarks($event, 'DeletionReason', 0)"
  ></ara-textarea>
  <div *ngIf="showDeletionmsg">
    <span class="error-msg-colour">{{
      "ACTIONTRACKER.PLEASE_ENTER_DELETION_REMARKS." | translate
    }}</span>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="deleteAction(deleteActionId)"
      label="Submit"
      class="active-btn orange-btn button-submit"
    ></button>
    <button
      type="button"
      pButton
      (click)="onCancelClick()"
      label="Cancel"
      class="active-btn orange-btn button-cancel"
    ></button>
  </p-footer>
</p-dialog>
<p-dialog
  header="Cancellaction Remarks"
  [(visible)]="cancelRecord"
  modal="modal"
  width="500"
>
  <ara-textarea
    [sourceText]="cancellationReason"
    [maxLength]="1000"
    disabled="false"
    (output)="getRemarks($event, 'CancellationReason', 0)"
  ></ara-textarea>
  <div *ngIf="showCancellationmsg">
    <span class="error-msg-colour">{{
      "ACTIONTRACKER.PLEASE_ENTER_CANCELLATION_REMARKS." | translate
    }}</span>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="cancelAction(cancelActionId)"
      label="Submit"
      class="active-btn orange-btn button-submit"
    ></button>
    <button
      type="button"
      pButton
      (click)="onCancel()"
      label="Cancel"
      class="active-btn orange-btn button-cancel"
    ></button>
  </p-footer>
</p-dialog>

<span *ngIf="ReportclosePopup">
  <p-dialog
    header="Report History"
    [(visible)]="ReportclosePopup"
    (onHide)="ReportclosePopUp()"
    [modal]="true"
  >
    <ara-report-log
      [ReportUserId]="ReportUserId"
      [ReportModule]="ReportModule"
      [ReportRecordId]="ReportRecordId"
    >
    </ara-report-log>
  </p-dialog>
</span>
